import { useState } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";

import { Fieldset } from "ui-components/Form";
import { FormTitle, DatePickerField, Text, SelectField, SwitchField } from "ui-components/Form";
import { useQuery } from "@tanstack/react-query";
import { getConsigneeOptions } from "services/data.internal.service";
import { countryOptions } from "layouts/views/common/options";

function CO({
  vendorOptions = [],
  headerRender,
  customerCode,
  control,
  errors,
  setValue,
  mode = "ADD",
}) {
  const [consigneeOptions, setConsigneeOptions] = useState([]);
  useQuery({
    queryKey: ["consignee-options", { customerCode }],
    queryFn: () => getConsigneeOptions({ customerCode }),
    enabled: customerCode !== null,
    onSuccess: (data) => {
      setConsigneeOptions(
        data.data.data.map((x) => {
          const { consigneeCode, ...consignee } = x;
          return {
            label: consigneeCode,
            value: consigneeCode,
            ...consignee,
          };
        })
      );
    },
  });
  const onConsigneeChange = (e, option) => {
    if(option===null){
      setValue("consigneeCode",option)
      return
    }
    const {
      value,
      consigneeName,
      shipAddress1,
      shipAddress2,
      shipPostcode,
      shipCity,
      shipState,
      shipCountry,
      shipPhoneNo,
      shipFaxNo,
    } = option;
    setValue("consigneeCode", value);
    setValue("cgCompany", consigneeName);
    setValue("cgAddress1", shipAddress1);
    setValue("cgAddress2", shipAddress2);
    setValue("cgPostcode", shipPostcode);
    setValue("cgCity", shipCity);
    setValue("cgState", shipState);
    setValue("cgCountry", shipCountry);
    setValue("cgPhoneNo", shipPhoneNo);
    setValue("cgFaxNo", shipFaxNo);
  };

  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = 6 / 2;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" && editable === false && { disabled: true, type: "text" }),
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "select":
        let options = [];
        let onChange = null;
        switch (data.name) {
          case "consigneeCode":
            options = consigneeOptions;
            onChange = onConsigneeChange;
            break;
          case "cgCountry":
            options = countryOptions;
            break;
          case "vendorCode":
            options = vendorOptions;
            break;
        }
        renderField = <SelectField field={fieldProps} options={options} onChange={onChange} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Collection Order" : "Add Collection Order"} />
      <MDBox mt={1.625}>
        {headerRender.map((rows, i) => {
          if (rows[0].type === "fieldset") {
            return (
              <Fieldset label={rows[0].label} key={i}>
                {rows[0].fieldsetRender.map((fs_rows, fs_i) => (
                  <Grid container spacing={3} key={fs_i}>
                    {fs_rows.map((fs_row, fs_index) => renderFn(fs_row, fs_index, fs_rows.length))}
                  </Grid>
                ))}
              </Fieldset>
            );
          }
          return (
            <Grid container spacing={3} key={i}>
              {rows.map((row, index) => renderFn(row, index, rows.length))}
            </Grid>
          );
        })}
      </MDBox>
    </MDBox>
  );
}

export default CO;
